import {
  ToggleButton,
  ToggleButtonGroup,
  toggleButtonGroupClasses,
  Stack,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import PanToolAltIcon from '@mui/icons-material/PanToolAlt';
import RoomIcon from '@mui/icons-material/Room';
import IosShareIcon from '@mui/icons-material/IosShare';
import { useCallback } from 'react';
import { MapTools } from '../../context/WorkspaceContext';
import { useWorkspace } from '../../context/WorkspaceContext/useWorkspace';
import { useSettings } from '../../context/SettingsContext/useSettings';
import { useNavigate } from 'react-router-dom';
import { buildFindFilterSearch } from '../../FindResults';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from '../../design-system';

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  [`& .${toggleButtonGroupClasses.grouped}`]: {
    height: '30px',
    width: '26px',
  },
}));

// ToggleButton's `value` prop is required and cannot be null, so the
// "no tool selected" state needs its own sentinel value.
const NO_TOOL = 'none';

const Toolchain = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const {
    store: { activeMapTool },
    enableDefaultTool,
    enableMarkerPointTool,
    onShareMap,
  } = useWorkspace();
  const {
    store: { activeFindFilter },
  } = useSettings();
  const findsHref = `/finds${buildFindFilterSearch(activeFindFilter)}`;
  const handleViewAll = useCallback(() => {
    navigate(findsHref);
  }, [findsHref, navigate]);

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <StyledToggleButtonGroup
        value={activeMapTool ?? NO_TOOL}
        size="small"
        exclusive
        aria-label={intl.formatMessage({
          id: 'map.findTools.ariaLabel',
          defaultMessage: 'Find map tools',
        })}
      >
        <ToggleButton
          title={intl.formatMessage({
            id: 'map.tool.defaultCursor',
            defaultMessage: 'Default map cursor',
          })}
          value={NO_TOOL}
          key={NO_TOOL}
          onClick={enableDefaultTool}
        >
          <PanToolAltIcon fontSize="small" />
        </ToggleButton>
        <ToggleButton
          title={intl.formatMessage({
            id: 'map.tool.addMarker',
            defaultMessage: 'Add marker point tool',
          })}
          value={MapTools.ADD_MARKER_POINT_TOOL}
          key={MapTools.ADD_MARKER_POINT_TOOL}
          onClick={enableMarkerPointTool}
        >
          <RoomIcon fontSize="small" />
        </ToggleButton>
        <ToggleButton
          value="share-map"
          title={intl.formatMessage({
            id: 'map.share.action',
            defaultMessage: 'Share map',
          })}
          key="share-map"
          onClick={onShareMap}
        >
          <IosShareIcon fontSize="small" />
        </ToggleButton>
      </StyledToggleButtonGroup>
      <Button onClick={handleViewAll} tone="neutral">
        <FormattedMessage id="map.viewAll" defaultMessage="View all" />
      </Button>
    </Stack>
  );
};

export { Toolchain };
